import React from "react";
import styles from "./styles.module.scss";
import classnames from "classnames";
import MemoSMobilePayLogo from "assets/icons/SmobilePayLogo";
import { PropagateLoader } from "react-spinners";
import PropTypes from "prop-types";

interface LoadingScreenProps {
  title?: string;
  isLoading?: boolean;
  type?: "dark" | "light";
}

const LoadingScreen = ({ title, isLoading, type = "dark" }: LoadingScreenProps) => {
  const isTypeLight = type === "light";

  return (
    <div
      data-testid={`loading-screen-${type}`}
      className={classnames(styles.loadingScreenWrapper, {
        [styles.loadingScreenWrapperActive]: isLoading,
        [styles.loadingScreenWrapperLight]: isTypeLight
      })}
    >
      <div className={styles.loadingScreenContent}>
        <MemoSMobilePayLogo style={{ marginBottom: !!title ? 0 : 15 }} data-testid="loading-screen-logo" />

        {title && (
          <div className={styles.loadingScreenText} data-testid="loading-screen-title">
            {title}
          </div>
        )}

        <PropagateLoader data-testid="loading-screen-loader" size={20} color="white" />
      </div>
    </div>
  );
};

LoadingScreen.propTypes = {
  isLoading: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.string
};

export default LoadingScreen;
